import { Box, Grid, FormControl, Select, MenuItem } from '@mui/material';
import useStateManager from 'components/hooks/useStateManager';
import React, { useEffect, useMemo, useCallback, useState } from 'react';
import styled from 'styled-components';
import ExamsTakenPerSchool from '../ExamsTakenPerSchool';
import ExamsTakenPerTeacher from '../ExamsTakenPerTeacher';
import DomainPerformanceGraph from '../ProficiencyGraph/DomainPerformanceGraph';
import ProficiencyPlacementExam from '../ProficiencyGraph/ProficiencyPlacementExam';
import StudentsMissing from '../StudentsMissing';
import { useOragnization } from 'components/hooks/oragnization/useOragnization';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { handleListExamGraphData } from 'store/organizations/thunks';
import {
  handleGetAllTeachers,
  handleGetDomainPerformanceGraphData,
  handleGetExamTakenPerSchoolProficiency,
  handleGetExamTakenPerTeacher,
  handleGetExamTakenProficiency,
  handleGetSubmissionStatusProficiency,
  handleListCourseInfo,
  handleListSchools,
} from 'store/standardexams';
import ExamReportSupport from '../ExamReportSupport';
import ContentLoading from 'modules/standardExamReport/contentLoading';
import { useExams } from 'store/exams/selectors';
import ProficiecnyExamTaken from './ProficiecnyExamTaken';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { groupBy } from 'lodash';
import ProficiecnyExamStack from './ProficiecnyExamStack';
import { useCurrentUser } from 'store/users/selectors';
import { useCurrentClass } from 'store/classes/selectors';

const years = new Date().getFullYear();
const upcomming_year = `${years}-${years + 1}`;
const downcomming_year = `${years - 1}-${years}`;

const proficiencyExamDetails = [
  {
    title: 'Juan Diaz',
    school: 'Mountain Elementary',
    proprity: 'High',
    priorityColor: '#df0d14',
  },
  {
    title: 'Claudia Martínez',
    school: 'Memorial High School',
    proprity: 'Mid',
    priorityColor: '#7b13c3',
  },
  {
    title: 'Maria Marco',
    school: 'Mountain Elementary',
    proprity: 'Low',
    priorityColor: '#078247',
  },
];

const flagDataProficiencyExam = [
  {
    title: 'Red = Urgent Support (high 50% failing, downward trend).',
    backgroundcolor: 'linear-gradient(180deg,#ef476f,#d7265e)',
  },
  {
    title: 'Orange = Needs Attention (moderate 25% failing, stagnant growth).',
    backgroundcolor: 'linear-gradient(180deg, #FFB703, #fb742b)',
  },
  {
    title: 'Green = On Track (80% passing  majority, positive trend).',
    backgroundcolor: 'linear-gradient(180deg, #03989e, #03989e)',
  },
];

const OverviewText = styled.span`
  color: black;
  font-size: 22px;
  font-weight: 800;
  display: flex !important;
  align-items: center;
`;

const school_level = [
  {
    value: 'high',
    label: 'HIGH SCHOOL',
  },
  {
    value: 'middle',
    label: 'MIDDLE SCHOOL',
  },
];

const DistrictpreferenceReport = () => {
  const { currentOrg } = useOragnization();
  const showAlert = useAlert();
  const currentUser = useCurrentUser();
  const currentClass = useCurrentClass();
  const exams = useExams();
  const currentYearSession = useMemo(() => moment().month()>7?upcomming_year:downcomming_year);
  const sessionOptions = useMemo(() => {
    const unique = Array.from(new Set((exams || []).map((e) => e.session))).filter(Boolean);
    return unique.length ? unique : [currentYearSession];
  }, [exams, currentYearSession]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    window.addEventListener('resize', () => {
      setWindowWidth(window.innerWidth);
    });
    return () => {
      window.removeEventListener('resize', () => {
        setWindowWidth(window.innerWidth);
      });
    };
  }, [window.innerWidth]);
  const [activeSession, setActiveSession] = useState(null);
  const [states, updateStates] = useStateManager({
    result: {},
    loading: {},
    filterRecords: {
      domainPerformanceGraph: {
        exam_type: '1',
        school_level: 'high',
      },
      placementExamResult: {
        exam_type: '1',
        school_level: 'high',
      },
    },
    optionsData: {
      school_level: school_level || [],
      exam_type: [],
    },
  });
  const [sumissionCount, setSumissionCount] = useState(0);
  const [missingCount, setMissingCount] = useState(0);
  const [constentLoading , setContentLoader] = useState(false);
  const [assignmentStatusCount, setAssignmentStatusCount] = useState({
    examTaken: 0,
    notStarted: 0,
    notFinished: 0,
    notAssigned: 0
  });
  useEffect(() => {
    if (exams && activeSession == null) {
        const grp = groupBy(exams, "session")
        if(grp[upcomming_year]){
          if (activeSession != upcomming_year) {
            setActiveSession(upcomming_year)
          }
        }else if (grp[downcomming_year]) {
          if (activeSession != downcomming_year) {
            setActiveSession(downcomming_year)
          }
        }
      }
  }, [exams, activeSession]);
  const exam_type = useMemo(() => {
    if (exams.length > 0) {
      const filterbasedontype = exams.filter(
        (exam) =>
          exam.exam_school === states?.filterRecords?.domainPerformanceGraph?.school_level &&
          exam.session === activeSession,
      );

      if (filterbasedontype.length > 0 && filterbasedontype[0]?.exams) {
        const final_exam_type = filterbasedontype[0].exams.map((exam) => ({
          value: String(exam.id),
          label: exam.displayName,
        }));
        return final_exam_type;
      }
    }
    return [];
  }, [exams, states?.filterRecords?.domainPerformanceGraph?.school_level, activeSession]);

  const placement_exam_type = useMemo(() => {
    if (exams.length > 0) {
      const filterbasedontype = exams.filter(
        (exam) =>
          exam.exam_school === states?.filterRecords?.placementExamResult?.school_level &&
          exam.session === activeSession,
      );

      if (filterbasedontype.length > 0 && filterbasedontype[0]?.exams) {
        const final_exam_type = filterbasedontype[0].exams.map((exam) => ({
          value: String(exam.id),
          label: exam.displayName,
        }));
        return final_exam_type;
      }
    }
    return [];
  }, [exams, states?.filterRecords?.placementExamResult?.school_level, activeSession]);

  useEffect(() => {
    if (exam_type.length > 0) {
      updateStates((prevState) => ({
        ...prevState,
        optionsData: {
          ...prevState.optionsData,
          exam_type: exam_type,
          placement_exam_type: placement_exam_type,
        },
      }));
    }
  }, [exam_type, updateStates]);

  const dispatch = useDispatch();

  const fetchInitalData = useCallback(async () => {
    try {
      updateStates((prevState) => ({
        ...prevState,
        loading: {
          ...prevState.loading,
          initial: true,
        },
      }));

      const getExamsType = exams.filter(
        (exam) =>
          exam.exam_school === 'high' && exam.session === (activeSession || currentYearSession),
      );
      const [
        courseInfoResult,
        getAllTeachers,
        getAllSchools,
        getExamTakenPerSchool,
        submissionStatusProficiency
      ] = await Promise.allSettled([
        dispatch(handleListCourseInfo({ organisationId: currentOrg.id })),
        dispatch(handleGetAllTeachers({ organisationId: currentOrg.id })),
        dispatch(handleListSchools({ organisationId: currentOrg.id })),
        dispatch(handleGetExamTakenPerSchoolProficiency({org_id: currentOrg.id,session: activeSession || currentYearSession,})),
        dispatch(handleGetSubmissionStatusProficiency(currentOrg.id, activeSession || currentYearSession))
      ]);

      const courseInfo = courseInfoResult.status === 'fulfilled' ? courseInfoResult.value : null;
      const getAllTeachersResult = getAllTeachers.status === 'fulfilled' ? getAllTeachers.value : null;
      const getAllListSchoolsResult = getAllSchools.status === 'fulfilled' ? getAllSchools.value : null;
      const getExamTakenPerSchoolResult = getExamTakenPerSchool.status === 'fulfilled' ? getExamTakenPerSchool.value : null;
      const submissionStatusProficiencyResult = submissionStatusProficiency.status === 'fulfilled' ? submissionStatusProficiency.value : null;
      if(submissionStatusProficiencyResult?.success){
        const { examTaken, notStarted, notFinished, notAssigned } = submissionStatusProficiencyResult.data || {};
        setAssignmentStatusCount({
          examTaken: examTaken || 0,
          notStarted: notStarted || 0,
          notFinished: notFinished || 0,
          notAssigned: notAssigned || 0,
        });
      }

      const result = {
        ...(getExamTakenPerSchoolResult?.data? { examTakenPerTeacher: getExamTakenPerSchoolResult?.data }: {}),
        ...(getExamTakenPerSchoolResult?.data? { examTakenPerSchool: getExamTakenPerSchoolResult?.data }: {}),
        ...(courseInfo?.data ? { courseInfo: courseInfo?.data } : {}),
        ...(getAllTeachersResult?.data ? { getAllTeachersResult: getAllTeachersResult?.data } : {}),
        ...(getAllListSchoolsResult?.data? { getAllListSchoolsResult: getAllListSchoolsResult?.data }: {}),
      };
      const optionsData = {
        ...(courseInfo?.data ? { courseInfo: courseInfo?.data } : {}),
        ...(getAllTeachersResult?.data ? { getAllTeachersResult: getAllTeachersResult?.data } : {}),
        ...(getAllListSchoolsResult?.data
          ? { getAllListSchoolsResult: getAllListSchoolsResult?.data }
          : {}),
      };
      updateStates((prevState) => ({
        ...prevState,
        result: {
          ...prevState.result,
          ...result,
        },
        optionsData: {
          ...prevState.optionsData,
          ...optionsData,
        },
      }));
    } catch (error) {
      console.log(error, 'error in fetching initial data');
    } finally {
      updateStates((prevState) => ({
        ...prevState,
        loading: {
          ...prevState.loading,
          initial: false,
        },
      }));
    }
  }, [currentOrg?.id, updateStates, activeSession, currentYearSession]);

  useEffect(() => {
    fetchInitalData();
  }, [currentOrg?.id, activeSession]);

  const handleOnChangeProficiencyPlacement = async (value) => {
    try {
      const payload = {
        id: currentOrg?.id,
        session: activeSession || currentYearSession,
        exam_type: value.exam_type,
        school_level: value.school_level,
      };

      updateStates((prevState) => ({
        ...prevState,
        loading: {
          ...prevState.loading,
          initial: true,
        },
        filterRecords: {
          ...prevState.filterRecords,
          placementExamResult: {
            exam_type: value?.exam_type || '',
            school_level: value?.school_level || '',
          },
        },
      }));

      const result = await dispatch(handleListExamGraphData(payload));
      if (result?.data) {
        updateStates((prevState) => ({
          ...prevState,
          result: {
            ...prevState.result,
            placementExamResult: result?.data || {},
          },
        }));
      }
    } catch (error) {
      console.log(error, 'error in handling proficiency placement');
    } finally {
      updateStates((prevState) => ({
        ...prevState,
        loading: {
          ...prevState.loading,
          initial: false,
        },
      }));
    }
  };

  const handleOnChangeDomainPerformanceGraph = async (value) => {
    try {
      // make inital true
      updateStates((prevState) => ({
        ...prevState,
        loading: {
          ...prevState.loading,
          initial: true,
        },
      }));
      const findSchoolType = exams.find(
        (exam) =>
          exam.exam_school === value?.school_level &&
          exam.session === (activeSession || currentYearSession),
      );
      const bookIDs = findSchoolType
        ? findSchoolType?.exams[Number(value?.exam_type) - 1]?.bookId
        : [];

      const payload = {
        org_id: currentOrg?.id,
        session: activeSession || currentYearSession,
        school_type: value?.school_level,
        book_ids: [bookIDs] || [],
      };
      console.log(payload, 'payload 2');
      const result = await dispatch(handleGetDomainPerformanceGraphData(payload));
      if (result?.status_code === 404) {
        showAlert('No submissions data found', 'error');
      }
      if (result?.data) {
        updateStates((prevState) => ({
          ...prevState,
          loading: {
            ...prevState.loading,
            initial: false,
          },
          filterRecords: {
            ...prevState.filterRecords,
            domainPerformanceGraph: value,
          },
          result: {
            ...prevState.result,
            domainPerformanceGraphData: result?.data || {},
          },
        }));
      }
    } catch (error) {
      console.log(error, 'error in handling domain performance graph');
    } finally {
      updateStates((prevState) => ({
        ...prevState,
        loading: {
          ...prevState.loading,
          initial: false,
        },
      }));
    }
  };

  const handleOnChangeSchool = async (value) => {
    try {
      updateStates((prevState) => ({
        ...prevState,
        loading: {
          ...prevState.loading,
          initial: true,
        },
        filterRecords: {
          ...prevState.filterRecords,
          selected_school: value,
        },
      }));

      let result = null;
      if (value === null || value === 'All') {
        result = await dispatch(
          handleGetExamTakenPerSchoolProficiency({
            org_id: currentOrg.id,
            session: activeSession || currentYearSession,
            school_id: null,
          }),
        );
      } else {
        result = await dispatch(
          handleGetExamTakenPerSchoolProficiency({
            org_id: currentOrg.id,
            session: activeSession || currentYearSession,
            school_id: value,
          }),
        );
      }

      if (result?.status_code === 200) {
        updateStates((prevState) => ({
          ...prevState,
          loading: {
            ...prevState.loading,
            initial: false,
          },
          result: {
            ...prevState.result,
            examTakenPerSchool: Number(result?.data),
          },
        }));
      }
    } catch (error) {
      console.log(error, 'error in handling change school');
    } finally {
      updateStates((prevState) => ({
        ...prevState,
        loading: {
          ...prevState.loading,
          initial: false,
        },
      }));
    }
  };

  const handleOnChangeTeacher = async (value) => {
    try {
      updateStates((prevState) => ({
        ...prevState,
        loading: {
          ...prevState.loading,
          initial: true,
        },
        filterRecords: {
          ...prevState.filterRecords,
          selected_teacher: value,
        },
      }));

      let result = null;
      if (value === 'All' || value === null) {
        result = await dispatch(
          handleGetExamTakenPerTeacher({
            org_id: currentOrg.id,
            session: activeSession || currentYearSession,
            teacher_id: null,
          }),
        );
      } else {
        result = await dispatch(
          handleGetExamTakenPerTeacher({
            org_id: currentOrg.id,
            session: activeSession || currentYearSession,
            teacher_id: value,
          }),
        );
      }
      updateStates((prevState) => ({
        ...prevState,
        loading: {
          ...prevState.loading,
          initial: false,
        },
        result: {
          ...prevState.result,
          examTakenPerTeacher: Number(result?.data),
        },
      }));
    } catch (error) {
      console.log(error, 'error in handling change teacher');
    } finally {
      updateStates((prevState) => ({
        ...prevState,
        loading: {
          ...prevState.loading,
          initial: false,
        },
      }));
    }
  };

  const handleOnChangeStudentMissing = async (value) => {
    try {
      updateStates((prevState) => ({
        ...prevState,
        filterRecords: {
          ...prevState.filterRecords,
          selected_student_missing: value,
        },
      }));
      setContentLoader(true)
      let result = null;
      if (value === null || value === 'All') {
        result = await dispatch(
          handleGetSubmissionStatusProficiency(
            currentOrg.id,
            activeSession || currentYearSession,
            null,
            null,
          ),
        );
      } else {
        result = await dispatch(
          handleGetSubmissionStatusProficiency(
            currentOrg.id,
            activeSession || currentYearSession,
            null,
            value,
          ),
        );
      }
      if(result?.success){
        const { examTaken, notStarted, notFinished, notAssigned } = result?.data || {};
        setAssignmentStatusCount({
          examTaken: examTaken || 0,
          notStarted: notStarted || 0,
          notFinished: notFinished || 0,
          notAssigned: notAssigned || 0,
        });
      }
      if (result?.status_code === 200) {
        updateStates((prevState) => ({
          ...prevState,
          loading: {
            ...prevState.loading,
            initial: false,
          }
        }));
      }
    } catch (error) {
      showAlert('Error in handling change student missing', 'error');
    } finally {
      setContentLoader(false)
      updateStates((prevState) => ({
        ...prevState,
        loading: {
          ...prevState.loading,
          initial: false,
        },
      }));
    }
  };

  const handleOnChangeStandardExamTaken = async (value) => {
    try {
      updateStates((prevState) => ({
        ...prevState,
        loading: {
          ...prevState.loading,
          initial: true,
        },
        filterRecords: {
          ...prevState.filterRecords,
          selected_proficiency_exam_taken: value,
        },
      }));

      let result = null;
      if (!value || value === 'All') {
        result = await dispatch(
          handleGetSubmissionStatusProficiency(
            currentOrg.id,
            activeSession || currentYearSession,
            null,
            null,
          ),
        );
      } else {
        result = await dispatch(
          handleGetSubmissionStatusProficiency(
            currentOrg.id,
            activeSession || currentYearSession,
            value,
            null,
          ),
        );
      }
      if(result?.success){
        const { examTaken, notStarted, notFinished, notAssigned } = result?.data || {};
        setAssignmentStatusCount({
          examTaken: examTaken || 0,
          notStarted: notStarted || 0,
          notFinished: notFinished || 0,
          notAssigned: notAssigned || 0,
        });
      }
      if (result?.status_code === 200) {
        updateStates((prevState) => ({
          ...prevState,
          loading: {
            ...prevState.loading,
            initial: false,
          }
        }));
      }
    } catch (error) {
      updateStates((prevState) => ({
        ...prevState,
        loading: {
          ...prevState.loading,
          initial: false,
        },
      }));
      showAlert('Error in handling change standard exam taken', 'error');
    } finally {
      updateStates((prevState) => ({
        ...prevState,
        loading: {
          ...prevState.loading,
          initial: false,
        },
      }));
    }
  };

  const [examReportSupportData, setExamReportSupportData] = useState([]);

  const excelBorderThin = {
    top: { style: 'thin', color: { argb: 'FFB0BEC5' } },
    bottom: { style: 'thin', color: { argb: 'FFB0BEC5' } },
    left: { style: 'thin', color: { argb: 'FFB0BEC5' } },
    right: { style: 'thin', color: { argb: 'FFB0BEC5' } },
  };

  const hexToArgbFont = (hex) => {
    if (!hex || typeof hex !== 'string') return 'FF37474F';
    const s = hex.replace('#', '').trim();
    if (s.length === 6) return `FF${s.toUpperCase()}`;
    return 'FF37474F';
  };

  const downloadExamReportSupportCSV = async () => {
    try {
      if (!examReportSupportData || examReportSupportData.length === 0) {
        showAlert('No data available for download', 'warning');
        return;
      }

      const ExcelJS = (await import('exceljs')).default;
      const { saveAs } = await import('file-saver');
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet('Teachers Needing Support', {
        views: [{ state: 'frozen', ySplit: 1 }],
      });

      sheet.columns = [
        { width: 28 },
        { width: 26 },
        { width: 20 },
        { width: 20 },
        { width: 16 },
      ];

      const headerRow = sheet.addRow([
        'Teacher Name',
        'School',
        'Result',
        'No. of Assignments',
        'Average Grade',
      ]);
      headerRow.height = 22;
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF02796D' },
        };
        cell.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 12 };
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        cell.border = excelBorderThin;
      });

      examReportSupportData.forEach((item, dataIdx) => {
        const row = sheet.addRow([
          item.title || '-',
          item.school || item.schoolName || '-',
          item.proprity || '-',
          item.noOfAssignments || item.uniqueAssignments || 0,
          item.averageGrade ?? 0,
        ]);
        row.height = 20;
        const rowFill = dataIdx % 2 === 0 ? 'FFFFFFFF' : 'FFF5F5F5';
        const resultArgb = hexToArgbFont(item.priorityColor);
        row.eachCell((cell, colNumber) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: rowFill },
          };
          cell.font = { size: 11, color: { argb: 'FF263238' } };
          cell.border = excelBorderThin;
          cell.alignment = { vertical: 'middle', wrapText: true };
          if (colNumber === 3) {
            cell.font = { bold: true, size: 11, color: { argb: resultArgb } };
          }
          if (colNumber === 4 || colNumber === 5) {
            cell.alignment = { horizontal: 'right', vertical: 'middle' };
          }
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(
        new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }),
        `teachers_needing_support_${moment().format('DD-MM-YY_hh-mm-ss')}.xlsx`,
      );
    } catch (error) {
      console.error('Error in downloading exam report support Excel:', error);
      showAlert('Error downloading Excel', 'error');
    }
  };

  return (
    <div>
      <ContentLoading isLoading={states.loading.initial || constentLoading} />
      <div className="flex flex-col gap-20">
        <div className="flex items-center justify-between proficencyHead">
          <OverviewText>
            1WAY&nbsp;
            <span style={{ color: '#fb742b', fontSize: '22px', fontWeight: '900' }}>
              PROFICIENCY
            </span>
          </OverviewText>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontSize: 12, fontWeight: 600 }}>Session:</span>
            <select
              value={activeSession}
              onChange={(e) => setActiveSession(e.target.value)}
              style={{
                border: '1px solid #e5e7eb',
                borderRadius: 8,
                padding: '6px 10px',
                fontSize: 12,
                fontWeight: 600,
                background: '#fff',
              }}
            >
              {(sessionOptions || []).map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="flex flex-row gap-20 flex-wrap items-center ">
          <Box
            sx={{
              width: '100%',
              border: '1px solid #e8e8e8',
              borderRadius: '12px',
              padding: '16px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                mb: 2,
              }}
            >
              <FormControl
                size="small"
                sx={{
                  minWidth: 150,
                  maxWidth: 250,
                  '& .MuiOutlinedInput-root': {
                    height: 32,
                    borderRadius: '8px',
                    fontSize: '12px',
                  },
                  '& .MuiSelect-select': {
                    py: 0.5,
                    px: 1,
                    fontSize: '12px',
                  },
                }}
              >
                <Select
                  value={states?.filterRecords?.selected_proficiency_exam_taken || 'All'}
                  displayEmpty
                  onChange={(e) => {
                    const value = e.target.value;
                    handleOnChangeStandardExamTaken(value);
                  }}
                  renderValue={(val) => {
                    if (val === 'All' || !val) return 'All';
                    const checkData = (states?.optionsData?.courseInfo || []).find((item) => item?.id === val);
                    return checkData?.title || 'All';
                  }}
                >
                  <MenuItem value="All" sx={{ fontSize: '12px' }}>
                    <em>All</em>
                  </MenuItem>
                  {(states?.optionsData?.courseInfo || []).map((item) => (
                    <MenuItem key={item?.id} value={item?.id} sx={{ fontSize: '12px' }}>
                      {item?.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Grid container spacing={2} sx={{ width: '100%', m: 0 }}>
              <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 3 }}>
                <ProficiecnyExamStack
                  value={assignmentStatusCount?.examTaken || 0}
                  label="Proficiency Exam"
                  subLabel="Taken"
                  backgroundColor="linear-gradient(90deg, #0B0B0B 0%, #2B2A9F 60%, #3533CD 100%)"
                />
                {/* <ProficiecnyExamTaken
                  title="Proficiency"
                  optionsData={states?.optionsData?.courseInfo || []}
                  value={states?.filterRecords?.selected_proficiency_exam_taken}
                  onChangeCourse={handleOnChangeStandardExamTaken}
                  count={sumissionCount || 0}
                  showFilter={false}
                /> */}
              </Grid>
              <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 3 }}>
                <ProficiecnyExamStack
                  value={assignmentStatusCount?.notStarted || 0}
                  label="Proficiency Exam"
                  subLabel="Not Started"
                  backgroundColor="linear-gradient(90deg, #ff3131, #ff914d)" />
                {/* <StudentsMissing
                  optionsData={states?.optionsData?.courseInfo || []}
                  value={states?.filterRecords?.selected_student_missing}
                  onChangeCourse={handleOnChangeStudentMissing} */}
                  {/* count={missingCount || 0}
                  showFilter={false}
                /> */}
              </Grid>
              <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 3 }}>
                <ProficiecnyExamStack
                  value={assignmentStatusCount?.notFinished || 0}
                  label="Proficiency Exam"
                  subLabel="Not Finished"
                  backgroundColor="linear-gradient(90deg, #8c52ff, #00bf63)"
                />
                {/* <ExamsTakenPerTeacher
                  optionsData={states?.optionsData?.getAllTeachersResult || []}
                  value={states?.filterRecords?.selected_teacher}
                  onChangeTeacher={handleOnChangeTeacher}
                  count={
                    typeof states?.result?.examTakenPerTeacher === 'number'
                      ? states?.result?.examTakenPerTeacher
                      : 0
                  }
                /> */}
              </Grid>
              <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 3 }}>
                <ProficiecnyExamStack
                  value={assignmentStatusCount?.notAssigned || 0}
                  label="Proficiency Exam"
                  subLabel="Not Assigned"
                  backgroundColor="linear-gradient(90deg, #004aad, #cb6ce6)"
                />
                {/* <ExamsTakenPerSchool
                  optionsData={states?.optionsData?.getAllListSchoolsResult || []}
                  value={states?.filterRecords?.selected_school}
                  onChangeSchool={handleOnChangeSchool}
                  count={
                    typeof states?.result?.examTakenPerSchool === 'number'
                      ? states?.result?.examTakenPerSchool
                      : 0
                  }
                /> */}
              </Grid>
            </Grid>
          </Box>
        </div>
        <Grid container spacing={2} sx={{ width: '100%', m: 0 }}>
          <Grid size={{ xs: 12, md: 12, lg: 5 }} sx={{ border:'1px solid #e8e8e8', borderRadius: '20px'}} item>
            <ExamReportSupport
              redirectTo="/proficiency"
              from="proficiency"
              examDetails={proficiencyExamDetails}
              flagData={flagDataProficiencyExam}
              activeSession={activeSession}
              flagEyeModal="proficiencyExamModal"
              onDataLoaded={setExamReportSupportData}
              onDownload={downloadExamReportSupportCSV}
            />
          </Grid>
          <Grid item size={{ xs: 12, md: 12, lg: 7 }} sx={{ width: '100%', m: 0, border:'1px solid #e8e8e8', borderRadius: '20px' }}>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                gap: 0,
                // border: '1px solid #e8e8e8',
                borderRadius: '12px',
                padding: '12px',
              }}
            >
              <Grid container sx={{ width: '100%', m: 0 }}>
                <Grid 
                  item 
                  size={{ xs: 12, md: 12, lg: 6 }} 
                  sx={{ 
                    borderRight: windowWidth >= 1280 ? '2px solid #e8e8e8' : 'none',
                    paddingRight: { xs: 0, lg: '20px' }
                  }}
                >
                  <DomainPerformanceGraph
                    rows={states?.result?.domainPerformanceGraphData || {}}
                    filterRecords={states?.filterRecords?.domainPerformanceGraph}
                    onChangeDomainPerformanceGraph={handleOnChangeDomainPerformanceGraph}
                    optionsData={{
                      school_level: states?.optionsData?.school_level || [],
                      exam_type: states?.optionsData?.exam_type || [],
                    }}
                    activeSession={activeSession}
                    exams={exams}
                    currentUser={currentUser}
                    currentClass={currentClass}
                  />
                </Grid>
                
                <Grid 
                  item 
                  size={{ xs: 12, md: 12, lg: 6 }}
                  sx={{
                    paddingLeft: { xs: 0, lg: '20px' }
                  }}
                >
                  <ProficiencyPlacementExam
                    onChangeProficiency={handleOnChangeProficiencyPlacement}
                    filterRecords={states?.filterRecords?.placementExamResult}
                    optionsData={{
                      school_level: states?.optionsData?.school_level || [],
                      exam_type: states?.optionsData?.placement_exam_type || [],
                    }}
                    activeSession={activeSession}
                    exams={exams}
                    currentUser={currentUser}
                    currentClass={currentClass}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default DistrictpreferenceReport;
